import React from 'react';

const Export: React.FC<React.PropsWithChildren> = () => (
  <path d="M4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z" />
);

export default Export;
